import { device } from "../../constants/mediaQueries";
import { useMediaQuery, useHasCursor } from "../../utils/style/useMediaQuery";

export const useClickMenu = () => {
  const narrowSurface = !useMediaQuery(device.md);
  const hasCursor = useHasCursor();

  return narrowSurface || !hasCursor;
};
